import { OKTA_TOKEN_KEY } from "./config";
import jwtDecode from "jwt-decode";
import { DateTime } from "luxon";

interface DecodedToken {
  exp: number; // Expiry time in Unix time (seconds since epoch)
  groups?: string[]; // Assuming groups are in an array
}

async function waitForOktaSession(timeout = 5000): Promise<string> {
  return new Promise((resolve, reject) => {
    const start = Date.now();
    const interval = setInterval(() => {
        const tokenString = sessionStorage.getItem(OKTA_TOKEN_KEY);
        if (tokenString) {
            clearInterval(interval);
            resolve(tokenString);
        } else if (Date.now() - start > timeout) {
            clearInterval(interval);
            reject(new Error('Okta token not found within timeout'));
        }
    }, 200);
  });

}

export function getOktaAccessToken() {
  // getting okta access token from the session storage
  // this application doesnt create token
  // it just uses the okta token created and stored in the session by fire weather application
  const oktaTokenString = sessionStorage.getItem(OKTA_TOKEN_KEY);

  if (oktaTokenString) {
    try {
      const oktaToken = JSON.parse(oktaTokenString);
      return oktaToken.accessToken.accessToken || null;
    } catch (error) {
      console.error("Failed to parse Okta token:", error);
      return null;
    }
  }

  return null;
};


// Fetches Okta tokens from session storage asynchronously; prevents issues with the interceptor when trying to retrieve tokens at startup
export async function getOktaAccessTokenAsync() {

  let oktaTokenString: string = "";
  const oktaTokenStringFromPromise = await waitForOktaSession().then(res => {
    oktaTokenString = res!;
  });
  if (oktaTokenString) {
    try {
      const oktaToken = JSON.parse(oktaTokenString);
      return oktaToken.accessToken.accessToken;
    } catch (error) {
      console.error("Failed to parse Okta token:", error);
      return null;
    }
  }

  return null;
}

export function decodeToken(token: string) {
  try {
    return jwtDecode<DecodedToken>(token);
  } catch (error) {
    console.error("Invalid token", error);
    return null;
  }
};


export function isTokenExpired(token:string) {
  if (!token) return true;
  const decodedToken = decodeToken(token);
  if (!decodedToken) {
    return true; // If token is invalid, treat it as expired
  }

  const expiryDate = DateTime.fromSeconds(decodedToken.exp);
  return expiryDate <= DateTime.now();
};